import { useState } from 'react';
import { FileOption } from '../types';

interface UseFileSelectionProps {
  initialStemWordFiles?: FileOption[];
  initialKeywordFiles?: FileOption[];
}

export const useFileSelection = (props?: UseFileSelectionProps) => {
  const [stemWordFiles, setStemWordFiles] = useState<FileOption[]>(props?.initialStemWordFiles || []);
  const [keywordFiles, setKeywordFiles] = useState<FileOption[]>(props?.initialKeywordFiles || []);
  const [selectedStemWordFile, setSelectedStemWordFile] = useState<string>('');
  const [selectedKeywordFile, setSelectedKeywordFile] = useState<string>('');
  const [customStemWordsPath, setCustomStemWordsPath] = useState('');
  const [customKeywordsPath, setCustomKeywordsPath] = useState('');
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);

  // Add custom stem words path
  const addCustomStemWordsPath = () => {
    if (!customStemWordsPath) return;
    
    const fileName = customStemWordsPath.split('/').pop() || customStemWordsPath;
    const newFile = {
      label: fileName,
      value: fileName,
      path: customStemWordsPath
    };
    
    if (!stemWordFiles.some(file => file.path === customStemWordsPath)) {
      setStemWordFiles(prev => [...prev, newFile]);
    }
    
    setSelectedStemWordFile(customStemWordsPath);
    setCustomStemWordsPath('');
  };

  // Add custom keywords path
  const addCustomKeywordsPath = () => {
    if (!customKeywordsPath) return;
    
    const fileName = customKeywordsPath.split('/').pop() || customKeywordsPath;
    const newFile = {
      label: fileName,
      value: fileName,
      path: customKeywordsPath
    };
    
    if (!keywordFiles.some(file => file.path === customKeywordsPath)) {
      setKeywordFiles(prev => [...prev, newFile]);
    }
    
    setSelectedKeywordFile(customKeywordsPath);
    setCustomKeywordsPath('');
  };

  // Update files and make a default selection
  const updateFiles = (stemWords: FileOption[], keywords: FileOption[]) => {
    setStemWordFiles(stemWords);
    setKeywordFiles(keywords);
    
    if (stemWords.length > 0 && !selectedStemWordFile) {
      setSelectedStemWordFile(stemWords[0].path);
    }
    
    if (keywords.length > 0 && !selectedKeywordFile) {
      setSelectedKeywordFile(keywords[0].path);
    }
  };

  return {
    stemWordFiles,
    keywordFiles,
    selectedStemWordFile,
    selectedKeywordFile,
    customStemWordsPath,
    customKeywordsPath,
    isLoadingFiles,
    setStemWordFiles,
    setKeywordFiles,
    setSelectedStemWordFile,
    setSelectedKeywordFile,
    setCustomStemWordsPath,
    setCustomKeywordsPath,
    setIsLoadingFiles,
    addCustomStemWordsPath,
    addCustomKeywordsPath,
    updateFiles
  };
};
